import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import RedRoundBtn from "../../Common_Component/Common_Btn/RedRoundBtn/RedRoundBtn";
import Select from "react-select";
import "./Common_Enquiry_Form.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Contact_Success_Modal from "../Common_Modal/Contact_Success_Modal/Contact_Success_Modal";
import Cookies from "js-cookie";
import { RegxExpression } from "../../../utils/common";
import { useRef } from "react";
import Contact_Reject_Modal from "../Common_Modal/Contact_Reject_Modal/Contact_Reject_Modal";

const Common_Enquiry_Form = ({ onHide, ...props }) => {
  const [modalExistShow, setModalExistShow] = React.useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [timer, setTimer] = useState(0);
  const [mobileEditable, setMobileEditable] = useState(true);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const otpRefs = useRef([]);

  const navigate = useNavigate();

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
  } = useForm();

  // Timer effect
  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    } else {
      // timer ended → allow editing again
      setMobileEditable(true);
    }
    return () => clearInterval(interval);
  }, [timer]);

  // Handle OTP input
  const handleOtpChange = (e, index) => {
    const value = e.target.value;

    // Only allow digits
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move forward if a number is typed
      if (value && index < otp.length - 1) {
        otpRefs.current[index + 1].focus();
      }
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index] === "" && index > 0) {
        // Move focus to previous box if current is empty
        otpRefs.current[index - 1].focus();

        // Also clear the previous box (optional)
        const newOtp = [...otp];
        newOtp[index - 1] = "";
        setOtp(newOtp);
      } else {
        // Clear current box normally
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      }
    }
  };

  // Send OTP API
  const sendOtp = async () => {
    const mobile = getValues("mobile");
    if (!/^[6-9]\d{9}$/.test(mobile)) {
      alert("Enter valid mobile number first");
      return;
    }

    try {
      await axios.post(process.env.REACT_APP_CRM_SEND_OTP_URL, { mobile });
      setOtpSent(true);
      setTimer(60); // countdown
      setMobileEditable(false); // lock while timer is running
      setOtpVerified(false); // reset verification state
      alert("OTP sent successfully");
    } catch (err) {
      console.error("Send OTP Error:", err);
      alert("Failed to send OTP");
    }
  };

  // Verify OTP API
  const verifyOtp = async () => {
    const mobile = getValues("mobile");
    const enteredOtp = otp.join("");
    if (enteredOtp.length !== 4) {
      alert("Enter 4-digit OTP");
      return;
    }

    try {
      await axios.post(process.env.REACT_APP_CRM_VERIFY_OTP_URL, {
        mobile,
        otp: enteredOtp,
      });
      setOtpVerified(true);
      //  don't disable mobile here
      alert("OTP Verified Successfully!");
    } catch (err) {
      console.error("Verify OTP Error:", err);
      alert("Invalid OTP");
    }
  };

  // Final Submit
  const onSubmit = async (data) => {
    if (!otpVerified) {
      alert("Please verify OTP before submitting");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("name", data?.name);
      formData.append("mobile", data?.mobile);
      formData.append("city", data?.city);
      formData.append("loan_type", data?.loan_type?.value);
      formData.append("employement_type", data?.occupation?.value);
      formData.append("message", data?.message);
      formData.append("api_key", process.env.REACT_APP_BASE_URL);

      const utmParams = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_content",
        "utm_term",
        "utm_id",
      ];

      utmParams.forEach((param) => {
        formData.append(param, Cookies.get(param) || "");
      });

      const remark =
        `Loan Type: ${data?.loan_type?.label}, City: ${data?.city}, ` +
        `Employment Type: ${data?.occupation?.label}, Message: ${data?.message}`;

      formData.append("remark", remark);

      const res = await axios.post(process.env.REACT_APP_CRM_URL, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // ✅ SUCCESS CASE
      if (res?.data?.success === true) {
        setShowSuccessModal(true);
        reset();

        setTimeout(() => {
          setShowSuccessModal(false);
          onHide?.();
          navigate("/thank-you");
        }, 2000);
      }

      // ❌ LEAD ALREADY EXISTS CASE
      else if (res?.data?.success === false) {
        setModalExistShow(true);
        setTimeout(() => setModalExistShow(false), 3000);
      }
    } catch (error) {
      console.error("Landing Form Error:", error);
      setModalExistShow(true);
      setTimeout(() => setModalExistShow(false), 3000);
    }
  };

  return (
    <section className="Common_Enquiry_Form">
      <div className="enquiry_form_div">
        <div className="heading_div">
          <p className="title">Request Financial Consultation</p>
        </div>

        <div className="form_holder">
          <Form className="enquiry_form" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              {/* Name */}
              <div className="col-12">
                <Form.Group className="form-group">
                  <Form.Control
                    type="text"
                    placeholder="Enter Full Name"
                    {...register("name", { required: "Name is required" })}
                  />
                  {errors?.name && (
                    <span className="invalid-feedback d-block">
                      {errors.name.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              {/* City */}
              <div className="col-12">
                <Form.Group className="form-group">
                  <Form.Control
                    type="text"
                    placeholder="Enter City"
                    {...register("city", { required: "City is required" })}
                  />
                  {errors?.city && (
                    <span className="invalid-feedback d-block">
                      {errors.city.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              {/* Mobile + Send OTP */}
              <div className="col-12">
                <Form.Group className="form-group">
                  <div className="otp_field_holder">
                    <Form.Control
                      type="tel"
                      placeholder="Enter Mobile Number"
                      maxLength={10}
                      disabled={!mobileEditable} //  only disable during timer
                      {...register("mobile", {
                        required: "Mobile is required",
                        pattern: {
                          value: /^[6-9]\d{9}$/,
                          message: "Enter valid 10-digit mobile",
                        },
                      })}
                    />

                    {/* Show Send/Resend OTP always, until verified */}
                    {!otpVerified && (
                      <p
                        className="verify_text"
                        onClick={sendOtp}
                        style={{ cursor: "pointer", color: "blue" }}
                      >
                        {otpSent ? "Resend OTP" : "Send OTP"}{" "}
                        {timer > 0 && `(${timer}s)`}
                      </p>
                    )}
                  </div>
                  {errors?.mobile && (
                    <span className="invalid-feedback d-block">
                      {errors.mobile.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              {/* OTP Input */}
              {otpSent && (
                <div className="col-12">
                  <Form.Group className="form-group">
                    <div className="otp_boxes">
                      {otp.map((digit, i) => (
                        <Form.Control
                          key={i}
                          type="text"
                          value={digit}
                          maxLength={1}
                          ref={(el) => (otpRefs.current[i] = el)}
                          onChange={(e) => handleOtpChange(e, i)}
                          onKeyDown={(e) => handleOtpKeyDown(e, i)}
                          style={{
                            width: "50px",
                            display: "inline-block",
                            margin: "5px",
                            textAlign: "center",
                            fontSize: "18px",
                          }}
                        />
                      ))}
                    </div>
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={verifyOtp}
                      disabled={otpVerified}
                      style={{ marginTop: "10px" }}
                    >
                      {otpVerified ? "OTP Verified ✅" : "Verify OTP"}
                    </Button>
                  </Form.Group>
                </div>
              )}

              {/* Loan Type */}
              <div className="col-md-6 col-12">
                <Form.Group className="form-group">
                  <Controller
                    name="loan_type"
                    control={control}
                    rules={{ required: "Select Financial Requirement" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={[
                          { value: "PERSONAL LOAN", label: "PERSONAL LOAN" },
                          { value: "HOME LOAN", label: "HOME LOAN" },
                          { value: "BUSINESS LOAN", label: "BUSINESS LOAN" },
                        ]}
                        placeholder="Financial Requirement"
                      />
                    )}
                  />
                  {errors.loan_type && (
                    <span className="invalid-feedback d-block">
                      {errors.loan_type.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              {/* Occupation */}
              <div className="col-md-6 col-12">
                <Form.Group className="form-group">
                  <Controller
                    name="occupation"
                    control={control}
                    rules={{ required: "Select Occupation" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={[
                          { value: "Salaried", label: "Salaried" },
                          { value: "Self Employment", label: "Self Employed" },
                        ]}
                        placeholder="Select Occupation"
                      />
                    )}
                  />
                  {errors.occupation && (
                    <span className="invalid-feedback d-block">
                      {errors.occupation.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              {/* Message */}
              <div className="col-12">
                <Form.Group className="form-group">
                  <Form.Control
                    type="text"
                    placeholder="Your Message (if any)"
                    {...register("message", {
                      required: "Message is required",
                    })}
                  />
                  {errors?.message && (
                    <span className="invalid-feedback d-block">
                      {errors.message.message}
                    </span>
                  )}
                </Form.Group>
              </div>
            </div>

            {/* Submit */}
            <div className="submit_btn">
              <RedRoundBtn btn_name={"Request a Callback"} type="submit" />
            </div>

            <span class="note_holder">
              By submitting this form, you agree to be contacted by Profcyma
              Financial Solutions or its partner institutions. We do not provide
              loans directly.
            </span>
          </Form>
        </div>
      </div>

      <Contact_Success_Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        title="Successfully Submitted"
        description="Your request has been submitted successfully."
      />

      <Contact_Reject_Modal
        show={modalExistShow}
        onHide={() => setModalExistShow(false)}
        title="Contact Number Already Exists"
        description="This mobile number is already registered. Please try another number."
      />
    </section>
  );
};

export default Common_Enquiry_Form;
